
import { updateContent } from "@/firebase/api/content";
import { deleteFileOnStorage } from "@/firebase/api/files";

export default {
  data: () => ({
    deletingFile: null,
    errorDialog: false,
    collectiveDeletion: false,
  }),
  computed: {
    errorDialogMessage() {
      const fileName = this.deletingFile.title;
      const message = `Um erro foi detectado no processo da exclusão do arquivo "${fileName || "Sem título"}". Deseja tentar novamente?`;
      return message;
    }
  },
  methods: {
    errorDialogAction(tryAgain) {
      this.errorDialog = false;
      if (tryAgain) this.deleteFile(this.deletingFile);
      else this.deletingFile = null;
    },

    deleteFileOnFirestore() {
      const { chapterID, contentID } = this.$route.params;
      const finder = currentFile => currentFile.title === this.deletingFile.title;
      let { files, images } = this
      const tempFiles = files || images
      const index = tempFiles.findIndex(finder);
      tempFiles.splice(index, 1);
      if (files) {
        files = tempFiles
        updateContent(chapterID, contentID, { files });
      }
      else {
        images = tempFiles
        updateContent(chapterID, contentID, { images });
      }
      this.deletingFile = null;
    },
    deleteFile(file) {
      const { chapterID, contentID } = this.$route.params;
      const filePath = `chapters/${chapterID}/contents/${contentID}/content/${file.title}`;
      this.deletingFile = file;
      deleteFileOnStorage(filePath)
        .then(this.deleteFileOnFirestore)
        .catch(() => {
          this.errorDialog = true;
        });
    }
  }
}